import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import {
  Modal,
  ModalDialog,
  ModalClose,
  Button,
  CircularProgress,
} from "@mui/joy";
import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";

interface SetupFormProps {
  open: boolean;
  handleClose: () => void;
}

export default function SetupForm({ open, handleClose }: SetupFormProps) {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState<string | null | undefined>();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      setLoading(false);
      return null;
    }

    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/settings?tab=finances`,
        payment_method_data: {
          allow_redisplay: "always",
        },
      },
    });

    if (error) {
      setErrorMessage(error.message);
    } else {
      handleClose();
      setErrorMessage(null);
    }
    setLoading(false);
  };

  return (
    <CssVarsProvider>
      <CssBaseline />
      <Modal open={open} onClose={handleClose}>
        <ModalDialog
          color="primary"
          layout="center"
          variant="plain"
          sx={{ width: "60%" }}
        >
          <ModalClose onClick={handleClose} />
          <form onSubmit={handleSubmit}>
            <PaymentElement />
            <Button
              type="submit"
              sx={{ marginTop: 1 }}
              disabled={!stripe || loading}
            >
              {loading ? <CircularProgress /> : "Save Payment Method"}
            </Button>
            {errorMessage && <div>{errorMessage}</div>}
          </form>
        </ModalDialog>
      </Modal>
    </CssVarsProvider>
  );
}
